export const oneWithZeroes = (zeroes: number = 0) => {
  return Number('1' + '0'.repeat(zeroes));
};

export const oneOfZeroes = (zeroes: number = 0) => {
  return 1 / oneWithZeroes(zeroes);
};



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/helpers/number.helpers.ts